import React from 'react';
import './Message.css';
import robotIcon from '../../logos_images/Ijs_logo_small_no_background.png'; // Import the user icon image
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';

// Generic link phrases (any language) that we replace with descriptive text for accessibility
const GENERIC_LINK_TEXTS = [
    'this link',
    'deze link',
    'هذا الرابط',
];

function getLinkText(children) {
    if (typeof children === 'string') return children.trim();
    if (children == null) return '';
    return React.Children.toArray(children).join('').trim();
}

function isGenericLinkText(text) {
    const normalized = text.toLowerCase();
    return GENERIC_LINK_TEXTS.some(
        (generic) => normalized === generic.toLowerCase() || text === generic
    );
}

const CONTACT_FORM_URL =
    'https://eloket.ijsselgemeenten.nl/formulier/nl-NL/IJsselgemeenten/scContactformulierSoZa.aspx/sscIntro/sscInleiding/f_G_Inleiding';

function AssistantMessage({ text, direction }) {
    const { t } = useTranslation();

    return (
        <div className="message-row assistant-message">
            <div className="icon-container">
                <img src={robotIcon} alt="logo IJsselgemeenten" className="message-icon"/>
            </div>
            <div className="message-bubble assistant-bubble" dir={direction} tabIndex={0}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        strong: ({ children }) => <>{children}</>,
                        a: ({ node, ...props }) => {
                            const linkText = getLinkText(props.children);
                            const isContactForm = props.href === CONTACT_FORM_URL;

                            const displayText = isGenericLinkText(linkText)
                                ? t('chat.linkLeadsToForm')
                                : props.children;

                            const ariaLabel = isContactForm
                                ? t('chat.contactFormDutchOnlyLabel')
                                : undefined;

                            return (
                                <a
                                    {...props}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={ariaLabel}
                                >
                                    {displayText}
                                </a>
                            );
                        }
                    }}
                >
                    {text}
                </ReactMarkdown>
            </div>
        </div>
    );
}

function AssistantThinkingMessage({ text, direction }) {
    const { t } = useTranslation();

    return (
        <div className="message-row assistant-message">
            <div className="icon-container">
                <img src={robotIcon} alt="logo IJsselgemeenten" className="message-icon" />
            </div>
            {/* Use the new thinking-message-bubble class */}
            <div className="thinking-message-bubble" dir={direction} tabIndex={0}>
                {/* Spinner container */}
                <div className="thinking-spinner-container">
                    <div className="ldsr"></div> {/* Spinner */}
                </div>
                {/* Text displayed beside the spinner */}
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        strong: ({ children }) => <>{children}</>,
                        a: ({ node, ...props }) => {
                            const linkText = getLinkText(props.children);
                            const isContactForm = props.href === CONTACT_FORM_URL;

                            const displayText = isGenericLinkText(linkText)
                                ? t('chat.linkLeadsToForm')
                                : props.children;

                            const ariaLabel = isContactForm
                                ? t('chat.contactFormDutchOnlyLabel')
                                : undefined;

                            return (
                                <a
                                    {...props}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={ariaLabel}
                                >
                                    {displayText}
                                </a>
                            );
                        }
                    }}
                >
                    {text}
                </ReactMarkdown>
            </div>
        </div>
    );
}

export { AssistantMessage, AssistantThinkingMessage };